import React, { Component } from "react";
import {
  AutoComplete,
  Button,
  Col,
  Form,
  Input,
  Modal,
  Row,
  Select,
  Tooltip
} from "antd";
import { withRouter } from "react-router-dom";
import { InfoCircleOutlined } from "@ant-design/icons";
import "./RegisterModal.css";
import { injectIntl } from "react-intl";
import { connect } from "react-redux";
import { getCountryCodes, cleanErrorMessage } from "../../actions/AuthAction";
import {
  sendNotification,
  validateEmail,
  validatePhoneNumber
} from "../../utils";
import PrivacyAndTermsFooter from "../sign-in-modal/PrivacyAndTermsFooter";
import { freePlanPrice } from "../../utils/constants";

const services = [
  {
    value: "Servicios de Publicidad"
  },
  {
    value: "Producción Audiovisual"
  },
  {
    value: "Imprenta"
  },
  {
    value: "Animación Digital"
  },
  {
    value: "Servicios/Asesorías"
  },
  {
    value: "Diseño Gráfico"
  },
  {
    value: "Community Manager"
  },
  {
    value: "Web"
  },
  {
    value: "Arquitectura"
  },
  {
    value: "Estrategias de Mercadeo"
  },
  {
    value: "Ilustraciones"
  },
  {
    value: "Estudiante"
  },
  {
    value: "Otro"
  }
];

export class RegisterModal extends Component {
  constructor(props) {
    super(props);

    this.state = {
      optionsServices: services,
      name: "",
      agent: "",
      email: "",
      phoneNumber: "",
      phoneCode: "",
      serviceSelected: ""
    };
  }

  componentDidMount() {
    this.props.getCountryCodes();
  }

  handleOnInputChange = e => {
    this.setState({ [e.target.name]: e.target.value });
  };

  handleSubmit = e => {
    const {
      name,
      agent,
      email,
      phoneNumber,
      serviceSelected,
      phoneCode
    } = this.state;
    const { intl } = this.props;
    e.preventDefault();
    if (name === "") {
      sendNotification(
        "warning",
        intl,
        "Debe ingresar el nombre de la empresa"
      );
      return;
    }
    if (agent === "") {
      sendNotification("warning", intl, "Debe ingresar su nombre");
      return;
    }
    if (!validateEmail(email)) {
      sendNotification("warning", intl, "Debe ingresar su email");
      return;
    }
    if (phoneCode === "") {
      sendNotification("warning", intl, "Debe ingresar su código de país");
      return;
    }
    if (!validatePhoneNumber(phoneNumber)) {
      sendNotification(
        "warning",
        intl,
        "Debe ingresar un número de teléfono válido"
      );
      return;
    }
    if (serviceSelected === "") {
      sendNotification(
        "warning",
        intl,
        "Debe ingresar el tipo de servicio que ofrece"
      );
      return;
    }
    this.setState({
      registering: true
    });
    this.props.handleSignUp(this.state);
  };

  componentWillUnmount() {
    this.props.cleanErrorMessage();
  }

  render() {
    const {
      showModal,
      handleHiddenModalRegister,
      handleShowModalSignIn,
      handleShowModalSuccessRegister,
      intl,
      countryCodes = []
    } = this.props;

    const {
      optionsServices,
      name,
      agent,
      email,
      phoneNumber,
      serviceSelected,
      phoneCode
    } = this.state;
    const { Option } = AutoComplete;
    const hash = "#";

    const optionsCountryCodes = countryCodes.map(item => (
      <Option
        key={`${item.code}${item.name}`}
        value={item.dial_code}
        style={{ height: 50, fontSize: 18 }}
      >
        <img src={item.image} alt={item.code} width={38} />{" "}
        {String(item.dial_code)} {item.name}
      </Option>
    ));
    return (
      <React.Fragment>
        <Modal
          visible={showModal}
          onCancel={handleHiddenModalRegister}
          width={540}
          footer={null}
          centered
          destroyOnClose
        >
          <Row justify={"space-between"}>
            <Col span={18}>
              <div style={{ fontSize: 21 }}>
                {intl.formatMessage({ id: "sign_in.welcome" })}
              </div>
              <div style={{ fontSize: 40, fontWeight: 500 }}>
                {intl.formatMessage({ id: "sign_up.title" })}
              </div>
            </Col>
            <Col span={6}>
              <div>{intl.formatMessage({ id: "sign_up.account" })}</div>
              <a
                onClick={() => {
                  handleShowModalSignIn();
                  handleHiddenModalRegister();
                }}
                href={hash}
              >
                {intl.formatMessage({ id: "sign_up.link_account" })}
              </a>
            </Col>
          </Row>
          <br />
          <Row>
            <Form
              layout={"vertical"}
              onSubmit={this.handleSubmit}
              id={"form-sign-in"}
            >
              <Form.Item>
                <label style={{ fontSize: 16, fontWeight: 400 }}>
                  {intl.formatMessage({ id: "sign_up.company_name" })}
                </label>
                <Input
                  name="name"
                  size={"large"}
                  value={name}
                  onChange={this.handleOnInputChange}
                  placeholder={intl.formatMessage({
                    id: "sign_up.company_name"
                  })}
                  style={{ height: 57 }}
                />
              </Form.Item>
              <Form.Item>
                <label style={{ fontSize: 16, fontWeight: 400 }}>
                  {intl.formatMessage({ id: "sign_up.question_name" })}
                </label>
                <Input
                  name="agent"
                  size={"large"}
                  value={agent}
                  onChange={this.handleOnInputChange}
                  placeholder={intl.formatMessage({ id: "sign_up.input_name" })}
                  style={{ height: 57 }}
                />
              </Form.Item>
              <Form.Item>
                <label style={{ fontSize: 16, fontWeight: 400 }}>
                  {intl.formatMessage({ id: "sign_in.label_email" })}
                </label>
                <Input
                  type="email"
                  name="email"
                  size={"large"}
                  value={email}
                  onChange={this.handleOnInputChange}
                  placeholder={intl.formatMessage({
                    id: "sign_in.input_email"
                  })}
                  style={{ height: 57 }}
                />
              </Form.Item>
              <Form.Item>
                <label style={{ fontSize: 16, fontWeight: 400 }}>
                  {intl.formatMessage({ id: "sign_up.question_number" })}
                </label>
                <Input
                  name="phoneNumber"
                  size={"large"}
                  placeholder={intl.formatMessage({
                    id: "sign_up.input_number"
                  })}
                  style={{ height: 57 }}
                  value={phoneNumber}
                  onChange={this.handleOnInputChange}
                  addonBefore={
                    <AutoComplete
                      className={"autocomplete-after"}
                      dropdownMatchSelectWidth={false}
                      dropdownStyle={{ width: 492 }}
                      style={{ height: 57, width: 70, cursor: "pointer" }}
                      dataSource={optionsCountryCodes}
                      optionLabelProp={"value"}
                      value={phoneCode}
                      onChange={e => {
                        this.setState({
                          phoneCode: e
                        });
                      }}
                    />
                  }
                  suffix={
                    <Tooltip
                      title={intl.formatMessage({ id: "sign_up.warn_number" })}
                      placement={"right"}
                      color={"blue"}
                    >
                      <InfoCircleOutlined style={{ color: "#8F90A6" }} />
                    </Tooltip>
                  }
                />
              </Form.Item>
              <Form.Item>
                <label style={{ fontSize: 16, fontWeight: 400 }}>
                  {intl.formatMessage({ id: "sign_up.question_service" })}
                </label>
                <Select
                  name="serviceSelected"
                  size={"large"}
                  style={{ height: 57 }}
                  value={serviceSelected}
                  onChange={e => {
                    this.setState({
                      serviceSelected: e
                    });
                  }}
                >
                  {optionsServices.map(item => (
                    <Option key={item.value} value={item.value}>
                      {item.value}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            </Form>
            <p className="register-plan-title">
              {intl.formatMessage({ id: "sign_up.plantitle" })}
            </p>
            <ul className="register-plan-item">
              <li>{intl.formatMessage({ id: "sign_up.planitem1" })}</li>
              <li>{intl.formatMessage({ id: "sign_up.planitem2" })}</li>
              <li>{intl.formatMessage({ id: "sign_up.planitem3" })}</li>
            </ul>
            <Button
              size={"large"}
              type={"primary"}
              block
              style={{ height: 57 }}
              onClick={e =>
                this.handleSubmit(e, handleShowModalSuccessRegister)
              }
              loading={this.props.registering}
            >
              {`${intl.formatMessage({
                id: "sign_up.button"
              })} (${freePlanPrice} USD)`}
            </Button>
          </Row>
          <br />
          <PrivacyAndTermsFooter />
        </Modal>
      </React.Fragment>
    );
  }
}

const mapStateToProps = state => {
  return {
    countryCodes: Object.values(state.countryCodes) || []
  };
};

const mapDispatchToProps = {
  getCountryCodes,
  cleanErrorMessage
};

export default injectIntl(
  withRouter(connect(mapStateToProps, mapDispatchToProps)(RegisterModal))
);
